import { getTestProps } from '../../../lib/helpers';

interface LogModalCodePreviewProps {
  /**
   * Code object
   */
  code?: string | Record<string, object | string>;
  /**
   * Test id
   */
  testId?: string;
}

const LogModalCodePreview = ({
  code,
  testId = '',
}: LogModalCodePreviewProps) => {
  return code ? (
    <pre
      className="rounded-lg p-2 bg-slate-200 dark:bg-slate-950"
      {...getTestProps(testId, `container`)}
    >
      <code>{JSON.stringify(code, null, 2)}</code>
    </pre>
  ) : null;
};

export default LogModalCodePreview;
